export enum StepStatus {
  COMPLETED = 'completed',
  ACTIVE = 'active',
  UPCOMING = 'upcoming',
  ERROR = 'error',
}

export const COMPLETED_ICON_CLASS_NAME = 'fa-solid fa-check';

export const ERROR_ICON_CLASS_NAME = 'fa-solid fa-xmark';

// Read out instead of the decorative error glyph, so assistive tech can tell a
// failed step from a normal one.
export const ERROR_STATUS_LABEL = 'Error';
